import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title: 'Zbeacon 智能物联平台',
    themeColor: '#0b7fc6'
  },
  mutations: {
    setTitle(state, t) { state.title = t }
  }
})
